export const name = '_ethereum'
export const displayName = 'Ethereum'
export const ticker = `${name}_ETH`
export const displayTicker = 'ETH'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'ethereum',
  'eth_bsc_f1d2a904',
  'optimism',
  'ethereumarbnova',
  'ethereumarbone',
  'aurora',
  'basemainnet',
]
